<!-- table.component.html -->
<ng-container *ngIf="!noData; else noDataTemplate">
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th width="320">Currency: USD</th>
          <th *ngFor="let year of years" class="text-center">{{ year }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="hasNonNullValue(revenuePerShare)">
          <td>
            <div class="d-flex align-items-center gap-1 justify-content-between">
              <div class="d-flex align-items-center gap-1">
                Revenue per Share (TTM)
              </div>
              <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
          </td>
          <td *ngFor="let revenue of revenuePerShare" class="text-center">
            {{ roundToTwoDecimals(revenue) ?? '-' }}
          </td>
        </tr>
        <!-- <tr *ngIf="hasNonNullValue(price_to_earning)">
            <td>Price to Earning</td>
            <td *ngFor="let revenue of price_to_earning" class="text-center">
              {{ roundToTwoDecimals(revenue) ?? '-' }}
            </td>
          </tr> -->

        <tr *ngIf="hasNonNullValue(ebitPerShareArray)">
          <td>
            <div class="d-flex align-items-center gap-1 justify-content-between">
              <div class="d-flex align-items-center gap-1">
                EBIT per Share (TTM)</div>
              <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
          </td>
          <td *ngFor="let ebit of ebitPerShareArray" class="text-center">
            {{ roundToTwoDecimals(ebit) ?? '-' }}
          </td>
        </tr>

        <tr *ngIf="hasNonNullValue(epsArray)">
          <td>
            <div class="d-flex align-items-center gap-1 justify-content-between">
              <div class="d-flex align-items-center gap-1">
                Earnings per Share (EPS) (TTM)</div>
              <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
          </td>
          <td *ngFor="let eps of epsArray" class="text-center">
            {{ roundToTwoDecimals(eps) ?? '-' }}
          </td>
        </tr>

        <!-- <tr *ngIf="hasNonNullValue(bookValuePerShare)">
            <td>Book Value per Share</td>
            <td *ngFor="let book of bookValuePerShare" class="text-center">
              {{ roundToTwoDecimals(book) ?? '-' }}
            </td>
          </tr> -->

        <!-- <tr *ngIf="hasNonNullValue(tangibleBookValuePerShare)">
            <td>Tangible Book Value per Share</td>
            <td *ngFor="let tangible of tangibleBookValuePerShare" class="text-center">
              {{ roundToTwoDecimals(tangible) ?? '-' }}
            </td>
          </tr> -->

        <tr *ngIf="hasNonNullValue(dividentPerShareArray)">
          <td>
            <div class="d-flex align-items-center gap-1 justify-content-between">
              <div class="d-flex align-items-center gap-1">
                Dividend per Share (TTM)</div>
              <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
          </td>
          <td *ngFor="let dividend of dividentPerShareArray" class="text-center">
            {{ roundToTwoDecimals2(dividend) ?? '-' }}
          </td>
        </tr>

        <tr *ngIf="hasNonNullValue(epsFwd)">
          <td>
            <div class="d-flex align-items-center gap-1 justify-content-between">
              <div class="d-flex align-items-center gap-1">
                EPS Forward </div>
              <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
          </td>
          <td *ngFor="let fwd of epsFwd" class="text-center">
            {{ roundToTwoDecimals(fwd) ?? '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #noDataTemplate>
  <div class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
    <p>No Data Available!</p>
  </div>
</ng-template>
